import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from './components/button/button.component';
import { BoundListComponent } from './components/combo/boundlist.component';
import { ComboComponent } from './components/combo/combo.component';
import { ImageTextComponent } from './components/imagetext/image-text.component';
import { BlockCopyPasteDirective } from './directives/block-copy-paste.directive';
import { HeightDirective } from './directives/height.directive';
import { WidthDirective } from './directives/width.directive';
import { CallbackPipe } from './pipes/callback.pipe';
import {RedirectGlobalService} from "./sharedServices/redirectGlobal.service";
import { SlideSwitcherComponent } from './components/slide-switcher';
import { CloseButtonComponent } from './components/close-btn';
import { TooltipDirective } from './directives/tooltip.directive';
import { TooltipManagerService } from '../sharedFeatures/sharedServices/internalServices/tooltip-manager.service';
import { DialogPopupBodyComponent } from '../sharedFeatures/dialog-component/dialog-popup-body.component';
import { DialogPopupComponent } from '../sharedFeatures/dialog-component/dialog-popup.component';
import { FilterByBooleanPipe } from './pipes/filter-by-boolean.pipe';
import { CustomSliderComponent } from './components/custom-slider';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component'

@NgModule({
	declarations: [
		ButtonComponent,
		ComboComponent,
		BoundListComponent,
		ImageTextComponent,
		WidthDirective,
		HeightDirective,
		CallbackPipe,
		BlockCopyPasteDirective,
		SlideSwitcherComponent,
		CustomSliderComponent,
		CloseButtonComponent,
		TooltipDirective,
		DialogPopupComponent,
		FilterByBooleanPipe,
		DialogPopupBodyComponent,
		LanguageSwitcherComponent
	],
    imports: [
        CommonModule,
		TranslateModule.forChild(),
        FormsModule
    ],
	exports: [
		CommonModule,
		FormsModule,
		ButtonComponent,
		ComboComponent,
		BoundListComponent,
		ImageTextComponent,
		WidthDirective,
		HeightDirective,
		CallbackPipe,
		BlockCopyPasteDirective,
		SlideSwitcherComponent,
		CustomSliderComponent,
		CloseButtonComponent,
		TooltipDirective,
		DialogPopupComponent,
		DialogPopupBodyComponent,
		LanguageSwitcherComponent
	],
    providers: [
		RedirectGlobalService,
		TooltipManagerService
    ]
})

export class SharedGuiSmallModule {
}